module.exports = __webpack_public_path__ + "static/media/md-ribbon.42633c14.svg";